module.exports = __webpack_public_path__ + "img/download-icon.ec7f6bc9.svg";